import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_volley-club/artifacts/dg49xs0l_Black%20Decorative%20Shield%20Volleyball%20Club%20Logo%20%28Sweatshirts%29%20%28T-Shirts%29.png";

export default function LandingPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-black">
      {/* Hero Section */}
      <div className="relative min-h-screen flex flex-col items-center justify-start pt-8 md:pt-12 overflow-hidden px-4">
        {/* Logo at Top Center */}
        <div className="relative z-10 mb-6 md:mb-8">
          <img src={LOGO_URL} alt="NL Volleyball Logo" className="w-80 h-80 sm:w-96 sm:h-96 md:w-128 md:h-128 object-contain" />
        </div>

        {/* Content Below Logo */}
        <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 text-center flex-1 flex flex-col justify-center">
          <div className="space-y-6 sm:space-y-8 animate-fade-in -mt-12 sm:-mt-16 md:-mt-20">
            {/* Main Heading - White text */}
            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white drop-shadow-2xl">
              NLV
            </h1>

            {/* Subheading */}
            <p className="text-base sm:text-lg md:text-xl max-w-2xl mx-auto text-gray-300 font-medium px-4">
              Join Amsterdam's most energetic volleyball community. Play, compete, and make lasting connections.
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center items-center pt-4 sm:pt-6 px-4">
              <Button
                data-testid="login-btn"
                onClick={() => navigate('/login')}
                className="w-full sm:w-auto bg-white hover:bg-gray-100 text-gray-900 font-semibold px-6 sm:px-8 py-5 sm:py-6 text-base sm:text-lg rounded-full shadow-2xl transform hover:scale-105"
              >
                Sign In
              </Button>
              <Button
                data-testid="join-club-btn"
                onClick={() => navigate('/register')}
                className="w-full sm:w-auto bg-orange-500 hover:bg-orange-600 text-white font-semibold px-6 sm:px-8 py-5 sm:py-6 text-base sm:text-lg rounded-full shadow-2xl transform hover:scale-105"
              >
                Join Us
              </Button>
              <Button
                data-testid="about-btn"
                onClick={() => navigate('/about')}
                variant="outline"
                className="w-full sm:w-auto border-2 border-white text-white hover:bg-white/10 font-semibold px-6 sm:px-8 py-5 sm:py-6 text-base sm:text-lg rounded-full shadow-2xl transform hover:scale-105"
              >
                About Us
              </Button>
              <Button
                data-testid="contact-btn"
                onClick={() => navigate('/contact')}
                variant="outline"
                className="w-full sm:w-auto border-2 border-white text-white hover:bg-white/10 font-semibold px-6 sm:px-8 py-5 sm:py-6 text-base sm:text-lg rounded-full shadow-2xl transform hover:scale-105"
              >
                Contact Us
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Features Section */}
      <div className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-6">
          <h2 className="text-4xl font-bold text-center mb-16 text-gray-900">Why Join Us?</h2>
          
          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center p-8 rounded-2xl bg-gradient-to-br from-orange-50 to-orange-100 hover-lift">
              <div className="text-5xl mb-4">⚡</div>
              <h3 className="text-2xl font-bold mb-3 text-gray-900">Regular Games</h3>
              <p className="text-gray-700">Weekly volleyball sessions at premium sports halls across Amsterdam</p>
            </div>

            <div className="text-center p-8 rounded-2xl bg-gradient-to-br from-blue-50 to-blue-100 hover-lift">
              <div className="text-5xl mb-4">👥</div>
              <h3 className="text-2xl font-bold mb-3 text-gray-900">Community</h3>
              <p className="text-gray-700">Meet passionate players and build lasting friendships</p>
            </div>

            <div className="text-center p-8 rounded-2xl bg-gradient-to-br from-orange-50 to-blue-100 hover-lift">
              <div className="text-5xl mb-4">🏆</div>
              <h3 className="text-2xl font-bold mb-3 text-gray-900">All Levels</h3>
              <p className="text-gray-700">From beginners to advanced players - everyone is welcome!</p>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-8">
        <div className="max-w-6xl mx-auto px-6 text-center">
          <p className="text-gray-400">&copy; 2025 NL Volleyball. Amsterdam, Netherlands.</p>
        </div>
      </footer>
    </div>
  );
}
